import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmenu = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 46,
	height: 46,
	viewBox: "0 0 46 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.2002 28.52V36.8C9.2002 38.7054 10.7448 40.25 12.6502 40.25H33.3502C35.2556 40.25 36.8002 38.7054 36.8002 36.8V28.52M9.2002 28.52V9.2C9.2002 7.29462 10.7448 5.75 12.6502 5.75H33.3502C35.2556 5.75 36.8002 7.29462 36.8002 9.2V28.52M9.2002 28.52H15.4102C16.012 31.529 18.654 33.695 21.7227 33.695H23.5877C26.6563 33.695 29.2984 31.529 29.9002 28.52H36.8002M14.3752 20.24H30.9352M14.3752 14.03H30.9352",
		stroke: "#B2B3B3",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEmenu;
